<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="400"
      max-width="350"
      offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn-toggle class="app-list-filter-date-btn-range" borderless>
        <v-text-field readonly
                      hide-details
                      :filled="filled"
                      :outlined="outlined"
                      :dense="dense"
                      clearable
                      v-on:click:clear="clear"
                      :value="getLabel"
                      :label="label"
                      v-bind="attrs"
                      v-on="on">
          <v-icon>event</v-icon>
        </v-text-field>
      </v-btn-toggle>
    </template>

    <v-card>
      <v-card-title>
        Filtrează de la - până la
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <app-datepicker @change="date2 = $event" :modal="modal" label="De la" v-model="date1"/>
          </v-col>
          <v-col cols="6">
            <app-datepicker :modal="modal" label="Pana la" v-model="date2"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" depressed>Interval</v-btn>
          </template>
          <v-list>
            <v-list-item-group @change="setDate">
              <v-list-item :value="item.value" selectable :key="item.text" v-for="item in intervals">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn
            text
            @click="menu = false">
          Închide
        </v-btn>
        <v-btn
            color="primary"
            text
            :disabled="!date1"
            @click="save">
          Aplică
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  data() {
    const currentMonth = [
      this.$moment().startOf('month').format('YYYY-MM-DD'),
      this.$moment().endOf('month').format('YYYY-MM-DD')
    ];

    const lastMonth = [
      this.$moment().subtract('1', 'months').startOf('month').format('YYYY-MM-DD'),
      this.$moment().subtract('1', 'months').endOf('month').format('YYYY-MM-DD'),
    ];

    const currentYear = [
      this.$moment().startOf('year').format('YYYY-MM-DD'),
      this.$moment().endOf('year').format('YYYY-MM-DD')
    ];

    return {
      date1: null,
      date2: null,
      menu: false,
      intervals: [
        {
          text: 'Azi',
          value: [
            this.$moment().format('YYYY-MM-DD'),
            this.$moment().format('YYYY-MM-DD')
          ]
        },
        {
          text: 'Ieri',
          value: [
            this.$moment().subtract('1', 'days').format('YYYY-MM-DD'),
            this.$moment().subtract('1', 'days').format('YYYY-MM-DD')
          ]
        },
        {
          text: 'Luna curentă',
          value: currentMonth
        },
        {
          text: 'Luna precedentă',
          value: lastMonth
        },
        {
          text: 'Anul curent',
          value: currentYear
        },
      ],
    }
  },


  watch: {
    value: function (value) {
      if (value[0]) {
        this.date1 = value[0];
      }
      if (value[1]) {
        this.date2 = value[1];
      }
    }
  },

  props: {
    label: String,
    value: Array,
    outlined: Boolean,
    modal: Boolean,
    filled: Boolean,
    dense: Boolean,
  },

  methods: {
    setDate: function(values) {
       this.date1 = values[0];
       this.date2 = values[1];
       this.save();
    },

    save: function () {
      if (this.date1 && !this.date2) {
        this.date2 = this.date1;
      }
      this.$emit('input', [this.date1, this.date2]);
      this.menu = false;
    },

    clear: function () {
      this.date1 = null;
      this.date2 = null;
      this.$emit('input', []);
    },
  },

  computed: {
    getLabel: function () {
      if (this.date1 === this.date2) {
        return this.date1;
      }
      let line = this.date1 && this.date2 ? ' - ' : '';
      return `${this.date1 || ''}${line}${this.date2 || ''}`;
    },
  },
}
</script>
<style lang="scss" scoped>
.app-list-filter-date-btn-range {
  display: flex;
  flex-flow: column;

  input {
    margin: 0 !important;
  }

  .v-btn {
    border-radius: 4px !important;
  }
}
</style>